export default __webpack_public_path__ + "static/media/m-pkhali-c.290fe737.png";